/**
 * Site-mode helper.
 *
 * NaturePulse and FarmersPulse share the exact same codebase and backend.
 * The build-time env var `REACT_APP_SITE` decides which "face" the frontend
 * shows.  Set it to `farmerspulse` in the FarmersPulse fork's `.env`:
 *
 *   REACT_APP_SITE=farmerspulse
 *
 * The default is `naturepulse` (the flagship site). This module is the
 * single source of truth for site-aware behaviour — routes, nav, home
 * page and marketing copy read from it.
 */

const SITE = (process.env.REACT_APP_SITE || "naturepulse").toLowerCase();

export const IS_FARMERSPULSE = SITE === "farmerspulse";
export const IS_NATUREPULSE = !IS_FARMERSPULSE;

export const NATUREPULSE_URL = process.env.REACT_APP_NATUREPULSE_URL || "https://naturepulse.net";
export const FARMERSPULSE_URL = process.env.REACT_APP_FARMERSPULSE_URL || "https://farmerspulse.com";

export const SITE_META = IS_FARMERSPULSE
  ? {
      site: "farmerspulse",
      brand: "FarmersPulse",
      brandShort: "Farmers Pulse",
      tagline: "The daily desk for growers.",
      description:
        "Crop insights, market signals, weather alerts and community observations — a working desk for farmers, from the SocialPulse network.",
      homePath: "/",
      externalHome: FARMERSPULSE_URL,
      counterpart: {
        label: "NaturePulse",
        url: NATUREPULSE_URL,
        prompt: "Explore the living planet",
      },
    }
  : {
      site: "naturepulse",
      brand: "NaturePulse",
      brandShort: "Nature Pulse",
      tagline: "Today's weather. Tomorrow's history.",
      description:
        "A global archive of weather, wildlife and everyday nature observations. Track. Share. Preserve.",
      homePath: "/",
      externalHome: NATUREPULSE_URL,
      counterpart: {
        label: "FarmersPulse",
        url: FARMERSPULSE_URL,
        prompt: "The daily desk for growers",
      },
    };
